import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { compose } from 'recompose'

// import Inferno, { linkEvent } from 'inferno';
// import Component from 'inferno-component';

import Map from './components/Map'
import LocationPicker from './components/LocationPicker'
import Filter from './components/Filter'
import Result from './components/Result'
import ResultDetail from './components/Result/ResultDetail'

import * as LocationActions from './actions/LocationActions'
import * as GeometryActions from './actions/GeometryActions'

import GeometryStore from './stores/GeometryStore'
import LocationStore from './stores/LocationStore'
import OfficeTypeStore from './stores/OfficeTypeStore'

import Translations from '../TranslationsWrapper'
import DataWrapper from '../DataWrapper'

import { getBreakpoint } from './breakpoint-util'

class LocationFinder extends Component {
  constructor(props) {
    super(props)

    // Bind events
    this.updateGeometry = this.updateGeometry.bind(this)
    this.getSearchResults = this.getSearchResults.bind(this)
    this.getOfficeTypes = this.getOfficeTypes.bind(this)

    // Variables to handle hiding the map on mobile
    this.resizeTimeout = false
    this.resizeDebounceDelay = 250
    this.hideMapOnBreakpoint = 'mobile'

    // Default state
    this.state = {
      geometry: null,
      searchResults: [],
      officeTypes: [],
      selectedSearchResult: null,
      showSearchResults: false,
      showMapOnMobile: getBreakpoint() !== this.hideMapOnBreakpoint
    }
  }

  handleResize = () => {
    // Debounce the resize event
    clearTimeout(this.resizeTimeout)
    // We need a timeout because after a resize event the callback is
    // faster than the CSS updating the breakpoint on the `head` element
    // Not using a timeout sometimes gives us the wrong breakpoint
    this.resizeTimeout = setTimeout(() => {
      this.setState({
        showMapOnMobile: getBreakpoint() !== this.hideMapOnBreakpoint
      })
    }, this.resizeDebounceDelay)
  }

  componentDidMount() {
    // handle resizing the browser
    window.addEventListener('resize', this.handleResize)
  }

  componentWillMount() {
    GeometryStore.on('change', this.updateGeometry)
    LocationStore.on('change', this.getSearchResults)
    OfficeTypeStore.on('change', this.getOfficeTypes)

    // Populate Locations & OfficeTypes
    LocationStore.populateLocations(this.props.model.Offices)
    OfficeTypeStore.populateOfficeTypes(this.props.model.OfficeTypes)

    // Get default state
    this.getSearchResults(false)
    this.getOfficeTypes()
  }

  componentWillUnmount() {
    GeometryStore.removeListener('change', this.updateGeometry)
    LocationStore.removeListener('change', this.getSearchResults)
    OfficeTypeStore.removeListener('change', this.getOfficeTypes)

    // Remove the resize event
    window.removeEventListener('resize', this.handleResize)
  }

  getSearchResults(showSearchResults) {
    this.setState({
      searchResults: LocationStore.getSearchResults(),
      selectedSearchResult: LocationStore.getSelectedSearchResult()
    })
  }

  getOfficeTypes() {
    this.setState({
      officeTypes: OfficeTypeStore.getOfficeTypes()
    })
  }

  updateGeometry() {
    const geometry = GeometryStore.getGeometry()

    this.setState({
      geometry: geometry,
      // showSearchResults prevents showing search results on first request
      showSearchResults: true
    })
  }

  render() {
    return (
      <div className="c-location-finder">
        <div className="c-location-finder__sidebar">
          {this.state.selectedSearchResult != null && (
            <div className="c-location-finder__sidebar__inner">
              <ResultDetail
                selectedSearchResult={this.state.selectedSearchResult}
              />
            </div>
          )}

          {this.state.selectedSearchResult == null && (
            <div className="c-location-finder__sidebar__inner">
              <h1>{this.props.translations.Title}</h1>
              <p>{this.props.translations.Search.Title}</p>
              <LocationPicker
                restrictToCountries={['nl', 'be', 'uk']}
                translations={this.props.translations}
              />
              {this.state.showSearchResults && (
                <div className="c-location-finder__results-wrapper">
                  <Filter
                    searchResults={this.state.searchResults}
                    officeTypes={this.state.officeTypes}
                  />
                  <Result searchResults={this.state.searchResults} />
                </div>
              )}
            </div>
          )}
        </div>
        {this.state.showMapOnMobile && (
          <Map
            geometry={this.state.geometry}
            searchResults={this.state.searchResults}
            selectedSearchResult={this.state.selectedSearchResult}
          />
        )}
      </div>
    )
  }
}

const elementId = 'js-location-finder'
const EnhancedLocationFinder = compose(
  DataWrapper(elementId),
  Translations(elementId)
)(LocationFinder)
// init
const element = document.getElementById(elementId)
if (element) {
  ReactDOM.render(<EnhancedLocationFinder />, element)
}

export default EnhancedLocationFinder
